import { render, staticRenderFns } from "./MarketingEditAdvertView.vue?vue&type=template&id=2d1a7a6f&scoped=true"
import script from "./MarketingEditAdvertView.vue?vue&type=script&lang=js"
export * from "./MarketingEditAdvertView.vue?vue&type=script&lang=js"
import style0 from "./MarketingEditAdvertView.vue?vue&type=style&index=0&id=2d1a7a6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1a7a6f",
  null
  
)

export default component.exports